/** Sparepé design tokens — light & dark palettes (synced with sparepe-design-system.css) */

export const THEME_STORAGE_KEY = 'sparepe-theme';

export const lightThemeTokens = {
  '--sp-bg-deep': '#f8fafc',
  '--sp-bg': '#ffffff',
  '--sp-bg-card': '#ffffff',
  '--sp-bg-surface': '#f1f5f9',
  '--sp-ink': '#0f172a',
  '--sp-ink-2': '#334155',
  '--sp-ink-3': '#64748b',
  '--sp-accent': '#d97706',
  '--sp-accent-lt': '#fffbeb',
  '--sp-accent-dk': '#b45309',
  '--sp-trust': '#2563eb',
  '--sp-trust-lt': '#eff6ff',
  '--sp-success': '#059669',
  '--sp-success-lt': '#ecfdf5',
  '--sp-border': '#e2e8f0',
  '--sp-border-md': '#cbd5e1',
  '--sp-shadow': '0 2px 8px rgba(15, 23, 42, 0.06)',
  '--sp-shadow-glow': '0 0 20px rgba(217, 119, 6, 0.12)',
  '--sp-shadow-premium': '0 4px 24px rgba(15, 23, 42, 0.08)',
};

export const darkThemeTokens = {
  '--sp-bg-deep': '#060a10',
  '--sp-bg': '#0d1117',
  '--sp-bg-card': '#161c27',
  '--sp-bg-surface': '#1c2333',
  '--sp-ink': '#f0f4ff',
  '--sp-ink-2': '#9baacf',
  '--sp-ink-3': '#5a6e9a',
  '--sp-accent': '#f59e0b',
  '--sp-accent-lt': '#1a1200',
  '--sp-accent-dk': '#fcd34d',
  '--sp-trust': '#3b82f6',
  '--sp-trust-lt': '#0f1e3d',
  '--sp-success': '#10b981',
  '--sp-success-lt': '#022c1a',
  '--sp-border': '#1e293b',
  '--sp-border-md': '#2d3f5c',
  '--sp-shadow': '0 2px 8px rgba(0, 0, 0, 0.5)',
  '--sp-shadow-glow': '0 0 20px rgba(245, 158, 11, 0.12)',
  '--sp-shadow-premium': '0 4px 32px rgba(0, 0, 0, 0.6)',
};

export const themeTokensByMode = {
  light: lightThemeTokens,
  dark: darkThemeTokens,
};
